import axios from "axios";
import { API_URL } from "../../constants";

export const GetSubCat = async (cat,ApiStatus) => {
    ApiStatus({ isLoader: true, isError: false, data: null });
    try {
        let res = await axios.get(API_URL + "user/sub_cat/"+cat);
        ApiStatus({ isLoader: false, isError: false, data: res.data });
    } catch (err) {
        ApiStatus({ isLoader: false, isError: true, data: null });
    }

}